<template>
    <!-- DataView -->
    <DataView :value="usersList" style="width: 100%;">
        <template #empty>
            <div class="w-full flex flex-row justify-content-start align-items-center p-2" style="background-color: var(--table-row-color);">
                <span>You haven't added any users yet. Get started by using the <span style="font-weight: var(--font-weight-bold);">Add a New User</span> button below.</span>
            </div>
        </template>
        <template #list="slotProps">
            <div class="grid grid-nogutter">

                <!-- Each row -->
                <div v-for="(item, index) in slotProps.items" :key="index" class="col-12 user-item w-full" :class="{ 'selected-user-item': (selectedUser) && selectedUser.id === item.id}" style="width: 100%; background-color: var(--users-list-row-color);">
                    <UserItem
                      :userItem="item" :isSelected="(selectedUser) && selectedUser.id === item.id" @clicked-item="$emit('clicked-user', item)" @delete="$emit('delete', item)"
                    />
                </div>

            </div>
        </template>
    </DataView>
</template>

<script setup>
// --- IMPORTS ---
import { computed } from 'vue';
// PrimeVue
import DataView from 'primevue/dataview'
// vue
import UserItem from './UserItem.vue'
// Others
import { useStore } from 'vuex';
import UsersUtils from '@/composables/UsersUtils';

const store = useStore()
const { allUsers } = UsersUtils(store)

// --- PROPS ---
const props = defineProps({
    selectedUser: Object
})

// --- Users List ---
const usersList = computed(() => [store.state.user.user ,...allUsers.value])

// --- EMITS ---
const emit = defineEmits(['clicked-user', 'delete'])
</script>

<style scoped>
/* Users list rows (items) */
.user-item:hover {
  cursor: pointer;
}
.user-item:hover:not(.selected-user-item) {
  background-color: var(--users-list-row-hover-color) !important;
}
.user-item.selected-user-item {
  background-color: var(--users-list-row-selected-color) !important;
}
</style>